import APIConstants from "../connection/APIConstants";
import APIManager from "../connection/APIManager";
import CacheStoreCredentials from "./CacheStoreCredentials";
import strings from '../values/strings/strings.js'

/*
USE CASE: AuthPerformLogin
Desc: Fetch API with (email/password) data to perform login
params: 
   - email: String of the user email
   - password: String of the user password
returns:
  - A promise that: resolve if the API returns successfull, and reject if there are errors
*/

const AuthPerformLogin = (email, password) => {
    return new Promise((resolve, reject) => {
        let headers = {}
        headers[APIConstants.header_auth_user] = email
        headers[APIConstants.header_auth_pass] = password
        
        //Send request to route
        APIManager.send("/login","POST",headers).then(res => {
            //Convert the response to json
            return res.json()
        }).then(async json => {
            //Store values and resolve
            await CacheStoreCredentials(json)            
            resolve(json)
        }).catch(e => {
            //Return error
            if(e.status === 401){
                reject(strings.getString('warn_login_unauthorized'))
            }else if(e.status === 500){
                reject(strings.getString('warn_login_servererror'))
            }else{                
                reject(strings.getString('warn_login_error'))
            }
            
        })      
    })
}

export default AuthPerformLogin;